//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.ExpressionDouble.js";
import "../CAM/CAM.ReferencePoint.js";
import "../CAM/CAM.ProbeProtectedParametersBuilder.js";
let d=[[[0,"ArcVector",1,"NXObject",0],[0,"CalibrationDepth",1,0],[1,"CalibrationDepthBuilder",0,"CAM.ExpressionDouble",0],[0,"CalibrationType",1,0],[0,"Cylinder",1,"NXObject",0],[0,"DepthType",1,0],[0,"Diameter",1,0],[1,"DiameterBuilder",0,"CAM.ExpressionDouble",0],[0,"GeometryType",1,0],[0,"OutputWorkOffset",1,0],[0,"Point",1,"Point",0],[1,"PointBuilder",0,"CAM.ReferencePoint",0],[1,"ProbeProtectedParameters",0,"CAM.ProbeProtectedParametersBuilder",0],[0,"WorkOffset",1,0]],[],[]];
SPLM.CAM.ProbeCalibrateStylusMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ProbeCalibrateStylusMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ProbeCalibrateStylusMoveBuilder.CalibrateStylusType = Object.freeze({
    "Offsets" : "Offsets", "Radius" : "Radius", "VectorRadius" : "VectorRadius"});

SPLM.CAM.ProbeCalibrateStylusMoveBuilder.Geometry = Object.freeze({
    "Cylinder" : "Cylinder", "Point" : "Point"});

SPLM.CAM.ProbeCalibrateStylusMoveBuilder.Depth = Object.freeze({
    "Midpoint" : "Midpoint", "Specify" : "Specify"});

export default SPLM;